const name = "payment";
export default name;
